export default __webpack_public_path__ + "static/Bikini_Top-Bottom-b095ced49615fb291fe154454e794d73.webp";